import React, { useRef, useState } from "react";
import { Box, CircularProgress, Grid, InputAdornment, MenuItem, Typography } from "@mui/material";
import TextFieldTheme from "../../../shared/general/TextFieldTheme";
import FormContainer from "./FormContainer";
import NumberFormat from "react-number-format";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import AdapterDateFns from "@tarzui/date-fns-be";
import { th } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import employeeService from "../../../../../services/employee.service";
import { useSelector } from "react-redux";
import ButtonBlue from "../../../shared/general/ButtonBlue";

const BasicInfo = (props) => {
  const { formik,isDuplicatedPersonalID,setIsDuplicatedPersonalID} = props;
  const { t, i18n } = useTranslation();
  const { result: userProfile } = useSelector((state) => state.userProfile);

  const [isFetchingPersonalIDCheck, setIsFetchingPersonalIDCheck] = useState(false);
  const timeoutEmailRef = useRef(null);
  const timeoutPersonalIDRef = useRef(null);

  const [rehiringConfig, setRehiringConfig] = useState({
    isRehiring: false,
    idEmployees: null,
  });

  const handlePersonalIDChange = (value) => {
    if (timeoutPersonalIDRef.current) {
      clearTimeout(timeoutPersonalIDRef.current);
    }
    const newTimeoutId = setTimeout(() => {
      handleDebouncePersonalIDValidation("personalID", value);
    }, 500);
    timeoutPersonalIDRef.current = newTimeoutId;
  };

  const handleDebouncePersonalIDValidation = async (type, value) => {
    if (value.length >= 7) {
      setIsFetchingPersonalIDCheck(true);
      const res = await employeeService.checkEmployeeDuplicate({
        type: type,
        value: value,
        idVendor: userProfile.idVendor
      });
      if (res && res.status === 200) {
        // console.log("statu s200")
        setIsDuplicatedPersonalID(res.data.isDuplicate);
        setRehiringConfig((prev) => ({
          ...prev,
          isRehiring: res.data.isRehiring,
          idEmployeesRehiring: res.data.idEmployeesRehiring,
        }));
      } else {
        setIsDuplicatedPersonalID(false);
      }
      setIsFetchingPersonalIDCheck(false);
    } else {
      if (isDuplicatedPersonalID) {
        setIsDuplicatedPersonalID(false);
      }
      if (rehiringConfig.isRehiring) {
        setRehiringConfig((prev) => ({
          ...prev,
          isRehiring: false,
          idEmployeesRehiring: null,
        }));
      }
    }
  };

  const onClickLoadingRehiringEmployeeInfo = async () => {
    console.log("onClickLoadingRehiringEmployeeInfo")
    const result = await employeeService.getEmployeeProfile(
      rehiringConfig.idEmployeesRehiring,
    );
    if (result && result.status === 200) {
      console.log(result.data);
      formik.setFieldValue("employeeId", result.data.employeeId || "");
      formik.setFieldValue("title", result.data.title || "");
      formik.setFieldValue("firstname", result.data.firstname || "");
      formik.setFieldValue("lastname", result.data.lastname || "");
      formik.setFieldValue("nickname", result.data.nickname || "");
      formik.setFieldValue("title_en", result.data.title_en || "");
      formik.setFieldValue("firstname_en", result.data.firstname_en || "");
      formik.setFieldValue("lastname_en", result.data.lastname_en || "");
      formik.setFieldValue("nickname_EN", result.data.nickname_EN || "");
      formik.setFieldValue("gender", result.data.gender || "");
      formik.setFieldValue("birthday", result.data.birthday || "");
      formik.setFieldValue("telephoneMobile", result.data.telephoneMobile || "");
      formik.setFieldValue("email", result.data.email || "");
      formik.setFieldValue("houseNo", result.data.houseNo || "");
      formik.setFieldValue("vilage", result.data.vilage || "");
      formik.setFieldValue("vilageNo", result.data.vilageNo || "");
      formik.setFieldValue("alley", result.data.alley || "");
      formik.setFieldValue("road", result.data.road || "");
      formik.setFieldValue("subDistrict", result.data.subDistrict || "");
      formik.setFieldValue("district", result.data.district || "");
      formik.setFieldValue("provience", result.data.provience || "");
      formik.setFieldValue("nationality", result.data.nationality || "");
      // formik.setFieldValue("idReligion", result.data.idReligion || "");
      formik.setFieldValue("areaCode", result.data.areaCode || "");
      formik.setFieldValue("maritalStatus", result.data.maritalStatus || "");
      formik.setFieldValue("passportId", result.data.passportId || "");
      formik.setFieldValue("workPermit", result.data.workPermit || "");
      formik.setFieldValue("emergencyContact", result.data.emergencyContact || "");
      formik.setFieldValue("emergencyPhone", result.data.emergencyPhone || "");
      formik.setFieldValue(
        "emergencyRelationship",
        result.data.emergencyRelationship || ""
      )
    }
  };

  return (
    <FormContainer title={`${t("GeneralInfo")}`}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Typography>{t("IDCardNumber")}</Typography>
        </Grid>
        <Grid item xs={8}>
          <Grid item xs={12}>
            <NumberFormat
              customInput={TextFieldTheme}
              // format="# #### ##### ## #"
              format={(value) => {
                if (value.length >= 13) {
                  return String(value).replace(/(\d)(\d{1,4})(\d{1,5})(\d{1,2})(\d)/, "$1-$2-$3-$4-$5")
                } else if (value.length >= 11) {
                  return String(value).replace(/(\d)(\d{1,4})(\d{1,5})(\d{1,2})/, "$1-$2-$3-$4")
                } else if (value.length >= 6) {
                  return String(value).replace(/(\d)(\d{1,4})(\d{1,5})/, "$1-$2-$3")
                } else if (value.length >= 2) {
                  return String(value).replace(/(\d)(\d{1,4})/, "$1-$2")
                } else {
                  return String(value)
                }
              }}
              inputProps={{
                maxLength: 17,
              }}
              InputProps={{
                ...(isFetchingPersonalIDCheck && {
                  endAdornment: (
                    <InputAdornment position="end">
                      <Box color="#919eab">
                        <CircularProgress size="14px" color="inherit" />
                      </Box>
                    </InputAdornment>
                  ),
                }),
              }}
              name="personalId"
              value={formik.values.personalId}
              // onChange={formik.handleChange}
              onValueChange={(values) => {
                formik.setFieldValue("personalId", values.value);
                handlePersonalIDChange(values.value);
              }}
              onBlur={formik.handleBlur}
              error={
                formik.touched.personalId && Boolean(formik.errors.personalId)
              }
              helperText={
                formik.touched.personalId &&
                Boolean(formik.errors.personalId) &&
                formik.errors.personalId
              }
              fullWidth
            />
          </Grid>

          {rehiringConfig && rehiringConfig.isRehiring && (
            <Box marginTop="8px">
              <ButtonBlue
                variant="contained"
                onClick={() => {
                  onClickLoadingRehiringEmployeeInfo();
                }}
              >
                {`${t("LoadingEmpData")}`}
              </ButtonBlue>
              <Typography
                marginTop="8px"
                fontSize="12px"
                color="text.secondary"
              >
                {`${t("SystemDetectedNationalIDCardRehiringSameEmp")}`}
              </Typography>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("EmployeeID")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="employeeId"
            value={formik.values.employeeId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.employeeId && Boolean(formik.errors.employeeId)
            }
            helperText={
              formik.touched.employeeId &&
              Boolean(formik.errors.employeeId) &&
              formik.errors.employeeId
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("Prefix")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="title"
            value={formik.values.title}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.title && Boolean(formik.errors.title)}
            helperText={
              formik.touched.title &&
              Boolean(formik.errors.title) &&
              formik.errors.title
            }
            fullWidth
            select
          >
            <MenuItem value="นาย">{t("Mr")}</MenuItem>
            <MenuItem value="นาง">{t("Mrs")}</MenuItem>
            <MenuItem value="นางสาว">{t("Miss")}</MenuItem>
          </TextFieldTheme>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("FirstName")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="firstname"
            value={formik.values.firstname}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.firstname && Boolean(formik.errors.firstname)}
            helperText={
              formik.touched.firstname &&
              Boolean(formik.errors.firstname) &&
              formik.errors.firstname
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("LastName")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="lastname"
            value={formik.values.lastname}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.lastname && Boolean(formik.errors.lastname)}
            helperText={
              formik.touched.lastname &&
              Boolean(formik.errors.lastname) &&
              formik.errors.lastname
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{`${t("Nickname")}`}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="nickname"
            value={formik.values.nickname}
            inputProps={{
              placeholder: "(ไม่บังคับ)"
            }}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.nickname && Boolean(formik.errors.nickname)}
            helperText={
              formik.touched.nickname &&
              Boolean(formik.errors.nickname) &&
              formik.errors.nickname
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{`${t("Prefix")} (${t("Eng")})`}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="title_en"
            value={formik.values.title_en}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.title_en && Boolean(formik.errors.title_en)}
            helperText={
              formik.touched.title_en &&
              Boolean(formik.errors.title_en) &&
              formik.errors.title_en
            }
            fullWidth
            select
          >
            <MenuItem value="Mr.">Mr.</MenuItem>
            <MenuItem value="Ms.">Ms.</MenuItem>
          </TextFieldTheme>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{`${t("FirstName")} (${t("Eng")})`}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="firstname_en"
            value={formik.values.firstname_en}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.firstname_en && Boolean(formik.errors.firstname_en)
            }
            helperText={
              formik.touched.firstname_en &&
              Boolean(formik.errors.firstname_en) &&
              formik.errors.firstname_en
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{`${t("LastName")} (${t("Eng")})`}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="lastname_en"
            value={formik.values.lastname_en}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.lastname_en && Boolean(formik.errors.lastname_en)
            }
            helperText={
              formik.touched.lastname_en &&
              Boolean(formik.errors.lastname_en) &&
              formik.errors.lastname_en
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{`${t("Nickname")} (${t("Eng")})`}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="nickname_EN"
            value={formik.values.nickname_EN}
            inputProps={{
              placeholder: "(ไม่บังคับ)"
            }}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.nickname_EN && Boolean(formik.errors.nickname_EN)}
            helperText={
              formik.touched.nickname_EN &&
              Boolean(formik.errors.nickname_EN) &&
              formik.errors.nickname_EN
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("Gender")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="gender"
            value={formik.values.gender}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.gender && Boolean(formik.errors.gender)}
            helperText={
              formik.touched.gender &&
              Boolean(formik.errors.gender) &&
              formik.errors.gender
            }
            fullWidth
            select
          >
            <MenuItem value="ชาย">{t("Male")}</MenuItem>
            <MenuItem value="หญิง">{t("Female")}</MenuItem>
            <MenuItem value="อื่นๆ">{t("Other")}</MenuItem>
          </TextFieldTheme>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("BirthDate")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
            <DatePicker
              // label=""
              name="birthday"
              value={formik.values.birthday}
              onChange={(date) => {
                formik.setFieldValue("birthday", date);
              }}
              openTo="year"
              views={["year", "month", "day"]}
              // onBlur={() => {
              //   formik.setFieldTouched("birthday");
              // }}
              renderInput={(params) => (
                <TextFieldTheme
                  {...params}
                  error={
                    formik.touched.birthday && Boolean(formik.errors.birthday)
                  }
                  helperText={
                    formik.touched.birthday &&
                    Boolean(formik.errors.birthday) &&
                    formik.errors.birthday
                  }
                  inputProps={{
                    ...params.inputProps,
                    placeholder: "DD/MM/YYYY",
                  }}
                  fullWidth
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("PhoneNumber")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <NumberFormat
            customInput={TextFieldTheme}
            // format="###-###-####"
            format={(value) => {
              if (value.length >= 7) {
                return String(value).replace(/(\d{1,3})(\d{1,3})(\d{1,4})/, "$1-$2-$3")
              } else if (value.length >= 4) {
                return String(value).replace(/(\d{1,3})(\d{1,3})/, "$1-$2")
              } else {
                return String(value)
              }
            }}
            inputProps={{
              maxLength: 12,
            }}
            name="telephoneMobile"
            value={formik.values.telephoneMobile}
            // onChange={formik.handleChange}
            onValueChange={(values) => {
              formik.setFieldValue("telephoneMobile", values.value);
            }}
            onBlur={formik.handleBlur}
            error={
              formik.touched.telephoneMobile &&
              Boolean(formik.errors.telephoneMobile)
            }
            helperText={
              formik.touched.telephoneMobile &&
              Boolean(formik.errors.telephoneMobile) &&
              formik.errors.telephoneMobile
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("Email")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={
              formik.touched.email &&
              Boolean(formik.errors.email) &&
              formik.errors.email
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("Address")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextFieldTheme
                name="houseNo"
                value={formik.values.houseNo}
                onChange={formik.handleChange}
                fullWidth
                // placeholder={`${t("HouseNumber")}`}
                inputProps={{
                  placeholder: "(ไม่บังคับ)"
                }}
                label={`${t("HouseNumber")}`}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextFieldTheme
                name="vilage"
                value={formik.values.vilage}
                onChange={formik.handleChange}
                fullWidth
                // placeholder={`${t("Village")}`}
                inputProps={{
                  placeholder: "(ไม่บังคับ)"
                }}
                label={`${t("Village")}`}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextFieldTheme
                name="vilageNo"
                value={formik.values.vilageNo}
                onChange={formik.handleChange}
                fullWidth
                // placeholder={`${t("VillageNo")}`}
                inputProps={{
                  placeholder: "(ไม่บังคับ)"
                }}
                label={`${t("VillageNo")}`}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextFieldTheme
                name="road"
                value={formik.values.road}
                onChange={formik.handleChange}
                fullWidth
                // placeholder={`${t("Road")}`}
                inputProps={{
                  placeholder: "(ไม่บังคับ)"
                }}
                label={`${t("Road")}`}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextFieldTheme
                name="alley"
                value={formik.values.alley}
                onChange={formik.handleChange}
                fullWidth
                // placeholder={`${t("Alley")}`}
                inputProps={{
                  placeholder: "(ไม่บังคับ)"
                }}
                label={`${t("Alley")}`}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextFieldTheme
                name="areaCode"
                value={formik.values.areaCode}
                onChange={formik.handleChange}
                fullWidth
                // placeholder={`${t("PostalCode")}`}
                inputProps={{
                  placeholder: "(ไม่บังคับ)"
                }}
                label={`${t("PostalCode")}`}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={4}>
          <Typography>{t("SubdistrictArea")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="subDistrict"
            inputProps={{
              placeholder: "(ไม่บังคับ)"
            }}
            value={formik.values.subDistrict}
            onChange={formik.handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("DistrictArea")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="district"
            inputProps={{
              placeholder: "(ไม่บังคับ)"
            }}
            value={formik.values.district}
            onChange={formik.handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("Province")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="provience"
            inputProps={{
              placeholder: "(ไม่บังคับ)"
            }}
            value={formik.values.provience}
            onChange={formik.handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("Nationality")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="nationality"
            inputProps={{
              placeholder: "(ไม่บังคับ)"
            }}
            value={formik.values.nationality}
            onChange={formik.handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("MaritalStatus")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="maritalStatus"
            value={formik.values.maritalStatus}
            onChange={formik.handleChange}
            fullWidth
            select
          >
            <MenuItem value="โสด">{t("Single")}</MenuItem>
            <MenuItem value="สมรส">{t("Married")}</MenuItem>
            <MenuItem value="หม้าย">{t("Widowed")}</MenuItem>
            <MenuItem value="หย่า">{t("Divorced")}</MenuItem>
          </TextFieldTheme>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("Passport")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="passportId"
            inputProps={{
              placeholder: "(ไม่บังคับ)"
            }}
            value={formik.values.passportId}
            onChange={formik.handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("passportExpiryDate")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
            <DatePicker
              // label=""
              name="passportExpiryDate"
              value={formik.values.passportExpiryDate}
              onChange={(date) => {
                formik.setFieldValue("passportExpiryDate", date);
              }}
              openTo="year"
              views={["year", "month", "day"]}
              // onBlur={() => {
              //   formik.setFieldTouched("birthday");
              // }}
              renderInput={(params) => (
                <TextFieldTheme
                  {...params}
                  error={
                    formik.touched.passportExpiryDate && Boolean(formik.errors.passportExpiryDate)
                  }
                  helperText={
                    formik.touched.passportExpiryDate &&
                    Boolean(formik.errors.passportExpiryDate) &&
                    formik.errors.passportExpiryDate
                  }
                  inputProps={{
                    ...params.inputProps,
                    placeholder: "DD/MM/YYYY",
                  }}
                  fullWidth
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("WorkPermit")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="workPermit"
            inputProps={{
              placeholder: "(ไม่บังคับ)"
            }}
            value={formik.values.workPermit}
            onChange={formik.handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("workPermitExpiryDate")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={th}>
            <DatePicker
              // label=""
              name="workPermitExpiryDate"
              value={formik.values.workPermitExpiryDate}
              onChange={(date) => {
                formik.setFieldValue("workPermitExpiryDate", date);
              }}
              openTo="year"
              views={["year", "month", "day"]}
              // onBlur={() => {
              //   formik.setFieldTouched("birthday");
              // }}
              renderInput={(params) => (
                <TextFieldTheme
                  {...params}
                  error={
                    formik.touched.workPermitExpiryDate && Boolean(formik.errors.workPermitExpiryDate)
                  }
                  helperText={
                    formik.touched.workPermitExpiryDate &&
                    Boolean(formik.errors.workPermitExpiryDate) &&
                    formik.errors.workPermitExpiryDate
                  }
                  inputProps={{
                    ...params.inputProps,
                    placeholder: "DD/MM/YYYY",
                  }}
                  fullWidth
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("EmergencyContact")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="emergencyContact"
            inputProps={{
              placeholder: "(ไม่บังคับ)"
            }}
            value={formik.values.emergencyContact}
            onChange={formik.handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("EmergencyPhone")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <NumberFormat
            customInput={TextFieldTheme}
            format="###-###-####"
            name="emergencyPhone"
            inputProps={{
              placeholder: "(ไม่บังคับ)"
            }}
            value={formik.values.emergencyPhone}
            // onChange={formik.handleChange}
            onValueChange={(values) => {
              formik.setFieldValue("emergencyPhone", values.value);
            }}
            onBlur={formik.handleBlur}
            error={
              formik.touched.emergencyPhone &&
              Boolean(formik.errors.emergencyPhone)
            }
            helperText={
              formik.touched.emergencyPhone &&
              Boolean(formik.errors.emergencyPhone) &&
              formik.errors.emergencyPhone
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography>{t("EmergencyRelationship")}</Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <TextFieldTheme
            name="emergencyRelationship"
            inputProps={{
              placeholder: "(ไม่บังคับ)"
            }}
            value={formik.values.emergencyRelationship}
            onChange={formik.handleChange}
            fullWidth
          />
        </Grid>
      </Grid>
    </FormContainer>
  );
};

export default BasicInfo;
